import { getFontSize, getFontWeight } from '../../../foundation/theme/typography.utils';
// Constants.
// -----------------------------------------------------------------------------
export const LABEL_SIZES_MAPPING = {
    inline: {
        s: {
            fontSize: getFontSize('s'),
            fontWeight: getFontWeight('extraBold')
        },
        xs: {
            fontSize: getFontSize('xs'),
            fontWeight: getFontWeight('extraBold')
        }
    },
    stacked: {
        s: {
            fontSize: getFontSize('s'),
            fontWeight: getFontWeight('extraBold')
        },
        xs: {
            fontSize: getFontSize('s'),
            fontWeight: getFontWeight('extraBold')
        }
    }
};
//# sourceMappingURL=FormGroupLabel.constants.js.map